import {VatDetail} from "@/scripts/Common";
import {VatType} from "@/Enums";

const createEmptyVatDetail = () => {
  const vatDetail: VatDetail = {
    id: 0,
    operatorId: 0,
    validFrom: '',
    vatRate: 0,
    vatType: VatType.Regular
  }

  return vatDetail;
}

const resetVatDetailObject = (originalObject: VatDetail, changedObject: VatDetail) => {
  changedObject.id = originalObject.id;
  changedObject.operatorId = originalObject.operatorId;
  changedObject.validFrom = originalObject.validFrom;
  changedObject.vatRate = originalObject.vatRate;
  changedObject.vatType = originalObject.vatType;
}

const vatDetailHasChanges = (originalObject: VatDetail, changedObject: VatDetail) => {
  return changedObject.id !== originalObject.id
    || changedObject.operatorId !== originalObject.operatorId
    || changedObject.validFrom !== originalObject.validFrom
    || changedObject.vatRate !== originalObject.vatRate
    || changedObject.vatType !== originalObject.vatType;
}

export {
  createEmptyVatDetail,
  resetVatDetailObject,
  vatDetailHasChanges
}
